import { FileText, Trash2 } from "lucide-react";

export default function DraftStatusBanner({
  lastSavedAt,
  notice,
  onDiscard,
  visible = true,
}) {
  if (!visible || !lastSavedAt) return null;

  const timeLabel = new Date(lastSavedAt).toLocaleString("pt-MZ", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div className="mb-4 flex flex-col gap-2 rounded-xl border border-amber-200 bg-amber-50/80 px-4 py-3 text-sm text-amber-900 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-2">
        <FileText className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" />
        <div>
          <p className="font-medium">Rascunho local (não submetido)</p>
          <p className="text-amber-800/90">
            Guardado automaticamente às {timeLabel}. Os dados só existem neste
            dispositivo até submeter o formulário.
          </p>
          {notice && (
            <p className="mt-1 text-xs text-amber-700">{notice}</p>
          )}
        </div>
      </div>
      {onDiscard && (
        <button
          type="button"
          onClick={onDiscard}
          className="inline-flex shrink-0 items-center gap-1.5 self-start rounded-lg border border-amber-300 bg-white px-3 py-1.5 text-xs font-medium text-amber-800 transition-colors hover:bg-amber-100 sm:self-center"
        >
          <Trash2 className="h-3.5 w-3.5" />
          Descartar rascunho
        </button>
      )}
    </div>
  );
}
